import { IAppConfig, IAppConfigRaw } from 'models/config.model'

export const getAppConfigFromConfigRaw = (
  config: IAppConfigRaw,
  countryCode = '',
): IAppConfig => ({
  amplitudeApiKey: config.amplitude_api_key,
  countryCode,
  firebaseConfig: config.firebase_config,
  giaApiKeys: config.gia_api_keys,
  googleAnalyticsId: config.google_analytics_id,
  liveChatWorkingHours: config.livechat,
})
